export const LOAD_ACTIVITIES = 'LOAD_ACTIVITIES';
export const LOAD_ACTIVITY_DATA = 'LOAD_ACTIVITY_DATA';
export const RESET_ACTIVITY_DATA = 'RESET_ACTIVITY_DATA';
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';
